import React from 'react';
import TeamHero from '../components/TeamHero';
import AboutTeamSection from '../components/AboutTeamSection';
import MissionVisionValues from '../components/MissionVisionValues';
import AwardsRecognitions from '../components/AwardsRecognitions';
import MeetTeamSection from '../components/MeetTeamSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import ContactUs from '../components/ContactUs';
import IndustryGrid from '../components/IndustryGrid';
import TechStackSection from '../components/TechStackSection';

function TeamPage() {
  return (
    <>
      <TeamHero />
      <AboutTeamSection />
      <MissionVisionValues />
      <AwardsRecognitions />
      <MeetTeamSection />
      <WhyChooseUsSection />
      <IndustryGrid />
      <TechStackSection />
      <ContactUs />
    </>
  );
}

export default TeamPage;
